<template>
  <div class="inner-wrapper">
    <nuxt />
  </div>
</template>

<script>

export default {
  middleware: [
    'fetchUser',
    'applicationForm',
    'hasVerifiedAccount'
  ]
}
</script>

<style lang="scss" scoped>

</style>
